module.exports = __webpack_public_path__ + "img/layer-stack.5df9c8fb.svg";